import { forwardRef } from "react";
import { StepProps, StepRef } from "../../types";
import OpenTextStep from "../../components/OpenTextStep";
import { useNavigate } from "react-router-dom";

export default forwardRef<StepRef, StepProps>(
  ({ onNext, signupState }, _ref) => {
    const navigate = useNavigate();
    return (
      <OpenTextStep
        title={"Lastly, how did you hear about us?"}
        subtitle={"We'd love to know who to thank!"}
        placeholder={"Instagram, Podcast, a friend, etc."}
        onNext={async (inputText) => {
          await onNext?.({ referralSource: inputText });
          navigate("/home?from=signup");
        }}
        initialText={signupState?.referralSource}
        skippable={true}
        buttonText={"Finish"}
        forcePrimaryButton={true}
        multiline={false}
      />
    );
  },
);
